module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-11.e04cf418.png";